/* eslint-disable global-require */
function reactComponent(Component, nodeList) {
  const React = require('react');
  const { createRoot } = require('react-dom/client');

  nodeList.forEach((node) =>
    createRoot(node).render(<Component {...node.dataset} />)
  );
}

export default [
  {
    name: 'goal-progress',
    loader: () => import('./modules/goal-progress')
  },
  {
    name: 'video-item',
    loader: () => import('./components/video-item')
  },
  {
    name: 'cart-modal',
    loader: () => import('./components/cart-modal')
  },
  {
    name: 'send-email-modal',
    loader: () => import('./components/send-email-modal')
  },
  {
    name: 'tooltip',
    loader: () => import('./components/tooltip')
  },
  {
    name: 'back-to-search-button',
    loader: () => import('./components/back-to-search-button')
  },
  {
    name: 'campaign-secondary-navigation',
    loader: () => import('./components/campaign-secondary-navigation')
  },
  {
    name: 'cookie-modal',
    loader: () => import('./components/cookie-modal')
  },
  {
    name: 'header',
    loader: () => import('./modules/header')
  },
  {
    name: 'gated-alert-banner',
    loader: () => import('./modules/gated-alert-banner')
  },
  {
    name: 'cookie-banner',
    loader: () => import('./modules/cookie-banner')
  },
  {
    name: 'footer',
    loader: () => import('./modules/footer')
  },
  {
    name: 'article-widget',
    loader: () => import('./modules/article-listing-widget')
  },
  {
    name: 'video-gallery-carousel',
    loader: () => import('./modules/video-gallery-carousel')
  },
  {
    name: 'campaign-carousel',
    loader: () => import('./modules/campaign-carousel')
  },
  {
    name: 'article-listing',
    loader: () => import('./modules/article-listing')
  },
  {
    name: 'accordion',
    loader: () => import('./modules/accordion')
  },
  {
    name: 'tabbed-content',
    loader: () => import('./modules/tabbed-content')
  },
  {
    name: 'tabbed-content-reusable',
    // eslint-disable-next-line import/no-cycle
    loader: () => import('./modules/tabbed-content-reusable')
  },
  {
    name: 'campaign-html-image-downloads',
    loader: () => import('./modules/campaign-html-image-downloads')
  },
  {
    name: 'campaign-toolkit-downloads',
    loader: () => import('./modules/campaign-toolkit-downloads')
  },
  {
    name: 'product-details',
    loader: () => import('./modules/product-details')
  },
  {
    name: 'latest-articles-carousel',
    loader: () => import('./modules/latest-articles-carousel')
  },
  {
    name: 'cart-page',
    loader: () => import('./modules/cart-page')
  },
  {
    name: 'sub-navigation-block',
    loader: () => import('./modules/sub-navigation-block')
  },
  {
    name: 'product-widget',
    loader: () => import('./modules/product-listing-widget')
  },
  {
    name: 'products-carousel',
    loader: () => import('./modules/products-carousel')
  },
  {
    name: 'products-grid',
    loader: () => import('./modules/products-grid')
  },
  {
    name: 'profile-card',
    loader: () => import('./modules/profile-card')
  },
  {
    name: 'share-page',
    loader: () => import('./modules/share-page')
  },
  {
    name: 'content-actions',
    loader: () => import('./modules/content-actions')
  },
  {
    name: 'toast',
    loader: () => import('./modules/toast')
  },
  {
    name: 'link-collapsible-content',
    loader: () => import('./components/link-collapsible-content')
  },
  {
    name: 'media-masonry',
    loader: () => import('./modules/media-masonry')
  },
  {
    name: 'image-flag',
    loader: () => import('./components/image-flag')
  },
  // React
  {
    name: 'product-listing',
    loader: () => import('./react-components/product-listing'),
    render: reactComponent
  },
  {
    name: 'video-listing',
    loader: () => import('./react-components/video-listing'),
    render: reactComponent
  },
  {
    name: 'search-listing',
    loader: () => import('./react-components/search-listing'),
    render: reactComponent
  },
  {
    name: 'fane',
    loader: () => import('./react-components/fane'),
    render: reactComponent
  },
  {
    name: 'email-form',
    loader: () => import('./react-components/email-form'),
    render: reactComponent
  },
  {
    name: 'content-listing',
    loader: () => import('./react-components/content-listing'),
    render: reactComponent
  },
  {
    name: 'session-schedule',
    loader: () => import('./react-components/session-schedule'),
    render: reactComponent
  },
  {
    name: 'alert-banner',
    loader: () => import('./modules/alert-banner')
  },
  {
    name: 'flip-card',
    loader: () => import('./components/flip-card')
  },
  {
    name: 'fnce-calculator',
    loader: () => import('./react-components/fnce-calculator'),
    render: reactComponent
  },
  {
    name: 'new-modal',
    loader: () => import('./components/new-modal')
  },
  {
    name: 'citation',
    loader: () => import('./components/citation')
  },
  {
    name: 'references',
    loader: () => import('./modules/references')
  },
  {
    name: 'membership-card-row',
    loader: () => import('./modules/membership-card-row')
  },
  {
    name: 'quote-card-row',
    loader: () => import('./modules/quote-card-row')
  }
];
